import { render, staticRenderFns } from "./OutputFan.vue?vue&type=template&id=06d1a2d5&"
import script from "./OutputFan.vue?vue&type=script&lang=ts&"
export * from "./OutputFan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports